import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=fa3f55c8&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=fa3f55c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3f55c8",
  null
  
)

export default component.exports